import PropTypes from 'prop-types';
import React from 'react';
import Icon from '~/components/Icon';
import { SignUpCardSubtitle, SignUpCardTitle } from '~/components/Text';
import { SimpleInnerContainer, StyledTextWrapper } from './Elements';

const SimpleInner = ({ icon, title, subTitle }) => {
  return (
    <SimpleInnerContainer>
      <Icon
        name={icon}
        height={115}
        width={115}
        color={null}
        inline
      />
      <StyledTextWrapper>
        <SignUpCardTitle>{title}</SignUpCardTitle>
        <SignUpCardSubtitle>{subTitle}</SignUpCardSubtitle>
      </StyledTextWrapper>
    </SimpleInnerContainer>
  );
};

SimpleInner.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default SimpleInner;
